import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext } from 'react'
import GeneralContext from '../contexts/GeneralContext'
import { useNavigate } from 'react-router-dom'

function ParticipantList() {
   const { participantsHome, setShowParticipants, get_userInfo, setGuestPageData, setCurrentTab, setShowComments } = useContext(GeneralContext)
   const navigator = useNavigate()
   const closeList = () => {
      setShowParticipants(false)
      setShowComments(false)
   }

   const redirectToPage = async (username) => {
      console.log(username)
      const data = await get_userInfo(username)
      console.log(data)
      setGuestPageData({
         name: data.attributes.name,
         description: data.attributes.description,
         imageSrc: data.attributes.profile_pic_src,
         username: data.attributes.username,
         id: data.id,
         tags: data.attributes.tags
      })
      if (data.id == sessionStorage.getItem('user')){
         setCurrentTab('Profile')
         navigator(`/main/profile`)
      }else{
         navigator(`/main/user/${username}`)
      }
      setShowComments(false)
      setShowParticipants(false)
   }

   return (
      <div className="home_participant_list">
         <div className="participant_list_top">
            <FontAwesomeIcon
               icon={faXmark}
               className="participant_list_top_X"
               onClick={closeList}
            />
         </div>
         <div className="participant_list_title">Participants</div>
         <div className="participant_list_listFrame">
            <ul className="participant_list_listFrame_list">
               {participantsHome.map((user) => {
                  return (
                     <li>
                        <div className="listFrame_list_personCard">
                           <div className="personCard_avatar">
                              <img
                                 className="personCard_avatar_image"
                                 src={
                                    user.profile_pic_src
                                 }
                                 alt="avatar"
                                 onClick={()=>{redirectToPage(user.username)}}
                              />
                           </div>
                           <div className="personCard_name" onClick={()=>{redirectToPage(user.username)}}>
                              {user.name}
                           </div>
                        </div>
                     </li>
                  )
               })}
            </ul>
         </div>
      </div>
   )
}
export default ParticipantList
